export default __webpack_public_path__ + "static/marion@2x-0d8a9c118c730499633e1a55068ea8d1.png";